import type {ReactElement} from 'react';
import React from 'react';
import {BaseItemSaturationOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-saturation-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';

export function ItemSaturationOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemSaturation = useGetKeyFromEffectsActiveItem('saturation');

  if (!activeItem || (activeItem && !('effects' in activeItem)) || activeItemSaturation === undefined) {
    throw new Error(`Item doesn't have effects property`);
  }

  const updateSaturation = (saturation: number, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        effects: {
          saturation,
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseItemSaturationOption saturation={activeItemSaturation} updateSaturation={updateSaturation} />;
}
